module.exports = __webpack_public_path__ + "img/kh.7f27fa73.svg";